var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0726 4.37512C7.85534 4.35156 4.39902 7.71965 4.37551 11.9274L4.37549 11.9302C4.32842 16.1427 7.7175 19.601 11.9278 19.6245L11.9306 19.6245C16.1431 19.6716 19.6013 16.2825 19.6249 12.0722L19.6249 12.0695C19.672 7.85689 16.2829 4.39864 12.0726 4.37512ZM3.37553 11.9204C3.40293 7.1515 7.31871 3.34855 12.0782 3.37514C16.8447 3.40177 20.6773 7.31515 20.6248 12.0792C20.5975 16.8451 16.6844 20.6769 11.9208 20.6245C7.1549 20.5971 3.32306 16.684 3.37553 11.9204Z",
    fill: "#ECFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.22533C11.5347 7.22533 11.1575 7.6026 11.1575 8.06799C11.1575 8.53337 11.5347 8.91064 12.0001 8.91064C12.4655 8.91064 12.8428 8.53337 12.8428 8.06799C12.8428 7.6026 12.4655 7.22533 12.0001 7.22533Z",
    fill: "#ECFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.657 11.5081C11.3044 11.5081 11.0186 11.2223 11.0186 10.8697C11.0186 10.517 11.3044 10.2312 11.657 10.2312L12.9785 10.2312V10.9496C12.9805 10.97 12.9815 10.9906 12.9815 11.0114V16.357C12.9815 16.7096 12.6957 16.9954 12.343 16.9954C11.9904 16.9954 11.7046 16.7096 11.7046 16.357V11.5081L11.657 11.5081Z",
    fill: "#ECFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.7ce6fd3c54bb86a13336d67a48b4d7ff.svg";
export { ForwardRef as ReactComponent };